import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { MESES_META, PAISES_META } from '../types/consumoMeta'
import type { ConsumoMetaFilters, PaisMeta } from '../types/consumoMeta'

interface Props {
  filters: ConsumoMetaFilters
  onFiltersChange: (filters: ConsumoMetaFilters) => void
  paisesDisponibles?: PaisMeta[]
}

export function ConsumoMetaFiltersBar({ filters, onFiltersChange, paisesDisponibles }: Props) {
  const now = new Date()
  const anio = filters.anio ?? now.getFullYear()
  const mes = filters.mes ?? now.getMonth() + 1

  const isCurrentMonth = anio === now.getFullYear() && mes === now.getMonth() + 1

  const prev = () => {
    if (mes === 1) {
      onFiltersChange({ ...filters, anio: anio - 1, mes: 12 })
    } else {
      onFiltersChange({ ...filters, anio, mes: mes - 1 })
    }
  }

  const next = () => {
    if (mes === 12) {
      onFiltersChange({ ...filters, anio: anio + 1, mes: 1 })
    } else {
      onFiltersChange({ ...filters, anio, mes: mes + 1 })
    }
  }

  const setPais = (pais: PaisMeta | undefined) => {
    onFiltersChange({ ...filters, pais })
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="inline-flex items-center gap-1 bg-white dark:bg-gray-800 rounded-full px-1.5 py-1 shadow-sm">
        <button
          onClick={prev}
          className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-all hover:shadow-sm"
        >
          <ChevronLeft className="h-4 w-4 text-gray-600 dark:text-gray-300" aria-hidden="true" />
        </button>
        <span className="text-sm font-semibold text-gray-700 dark:text-gray-200 capitalize px-4 select-none">
          {MESES_META[mes - 1].label} {anio}
        </span>
        <button
          onClick={next}
          disabled={isCurrentMonth}
          className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-25 disabled:cursor-not-allowed transition-all hover:shadow-sm"
        >
          <ChevronRight className="h-4 w-4 text-gray-600 dark:text-gray-300" aria-hidden="true" />
        </button>
      </div>

      {paisesDisponibles && paisesDisponibles.length > 0 && (
        <div className="inline-flex items-center gap-1 bg-white dark:bg-gray-800 rounded-full px-1.5 py-1 shadow-sm">
          <button
            onClick={() => setPais(undefined)}
            className={cn(
              'px-3 py-1 rounded-full text-sm font-medium transition-all',
              !filters.pais
                ? 'bg-emerald-500 text-white shadow-sm'
                : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
            )}
          >
            Todos
          </button>
          {PAISES_META.filter(({ value }) => paisesDisponibles.includes(value)).map(({ value, label }) => (
            <button
              key={value}
              onClick={() => setPais(value)}
              className={cn(
                'px-3 py-1 rounded-full text-sm font-medium transition-all',
                filters.pais === value
                  ? 'bg-emerald-500 text-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
              )}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
